import { api } from '@/shared/api/api';

export const fetchUserList = async username => {
  const { data: userList } = await api.get(`/api/users/getList?name=${username}`);

  return userList.map(user => ({
    label: user.name || user.email,
    value: user.id,
  }));
};
